import styled from 'styled-components';
import { editorLeftTabBarWidth } from 'styles/commonStyles';
import HomeButton from './components/HomeButton';
import ProjectName from './components/ProjectName/ProjectName';
import CreditButton from './components/CreditButton';
import DownloadButton from './components/DownloadButton';
import SaveButton from './components/SaveButton';
import RunButton from './components/RunButton';
import { EDITOR_HEADER_HEIGHT } from 'constants/style';

const Container = styled.header`
  height: ${`${EDITOR_HEADER_HEIGHT}px`};
  background-color: ${(props) => props.theme.global.bgColor};
  border-bottom: 1px solid ${(props) => props.theme.global.borderColor};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 20px;
`;

const LeftView = styled.div`
  display: flex;
  align-items: center;
`;

const HomeButtonView = styled.div`
  ${editorLeftTabBarWidth};
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  &::after {
    position: absolute;
    right: 0;
    content: '';
    height: 20px;
    border-right: 1px solid ${(props) => props.theme.global.borderColor};
  }
`;

const RightView = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`;

const RightButtonView = styled.div`
  display: flex;
  gap: 8px;
`;

const EditorHeader = () => {
  return (
    <Container>
      <LeftView>
        <HomeButtonView>
          <HomeButton />
        </HomeButtonView>
        <ProjectName />
      </LeftView>
      <RightView>
        <CreditButton />
        <RightButtonView>
          <DownloadButton />
          {/* <GuideButton /> */}
          <SaveButton />
          {/* <MoreButton /> */}
          <RunButton />
        </RightButtonView>
      </RightView>
    </Container>
  );
};

export default EditorHeader;
